import React from 'react';
import { useUpdateConsentMutation } from '../../redux/slices/consent';
import { GrantConsentButton } from '../GrantConsentButton';
import { WithdrawConsentButton } from '../WithdrawConsentButton';

export const ConsentButton = ({ termsId, termsItemId, revision, status, disabled }) => {
  const currentStatus = status?.status;
  const [ updateConsent ] = useUpdateConsentMutation();
  const handleUpdateConsent = (status) => {
    updateConsent({ 
      termsId, 
      termsItemId, 
      revision, 
      payload: { 
        status
      } 
    });
  };

  return currentStatus === "Granted"
    ? <WithdrawConsentButton onClick={() => handleUpdateConsent("Withdrawn")} disabled={disabled} />
    : <GrantConsentButton onClick={() => handleUpdateConsent("Granted")} disabled={disabled} />
};